import React, { useState } from 'react';
import { Button, pxToRem } from '@modernhealth/vital-components';
import { Trans, useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { navigationService } from 'src/config/rootService';
import { useDoesUserQualifyForTherapy } from 'src/modules/user/hooks/userHooks';
import { CrisisModal } from 'src/shared/components/CrisisModal';

import { InlineButtonLink } from './InlineButtonLink';
import { ErrorView } from './ErrorView';
import noMessages from '../assets/no-messages.svg';

const StyledButton = styled(Button)`
    margin: ${pxToRem(8, 0)};
`;

export const NoConversations: React.FC = () => {
    const [crisisModalVisible, setCrisisModalVisible] = useState(false);
    const { t } = useTranslation();
    const userQualityForTherapy = useDoesUserQualifyForTherapy();

    return (
        <>
            <CrisisModal
                visible={crisisModalVisible}
                onClose={() => setCrisisModalVisible(false)}
            />
            <ErrorView
                imgSrc={noMessages}
                title={t('messaging:no_conversations.title')}
                description={t('messaging:no_conversations.description')}
                buttons={
                    <>
                        {!!userQualityForTherapy && (
                            <StyledButton
                                role="link"
                                fluid
                                onClick={() => {
                                    navigationService.navigate('/work-with-a-therapist');
                                }}
                            >
                                {t('messaging:button.match_with_therapist')}
                            </StyledButton>
                        )}
                        <StyledButton
                            role="link"
                            fluid
                            variant={userQualityForTherapy ? 'secondary' : 'primary'}
                            onClick={() => {
                                navigationService.navigate('/work-with-a-coach');
                            }}
                        >
                            {t('messaging:button.match_with_coach')}
                        </StyledButton>
                    </>
                }
                footnote={
                    <Trans
                        t={t}
                        i18nKey="messaging:no_conversations.access_crisis_resources"
                        components={{
                            'access-crisis-resources-link': (
                                <InlineButtonLink onClick={() => setCrisisModalVisible(true)} />
                            ),
                        }}
                    />
                }
            />
        </>
    );
};
